import http from './_http'
import config from "@/config";

/**
 * 会员中心列表
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const vipData = (params = {}) => {
    return http({
        url: '/vip/data',
        method: 'get',
        params,
        meta: {
            login: true,
            loading: true,
        },
    });
}

/**
 * 会员体验卡转发
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const vipShareAdd = (params = {}) => {
    return http({
        url: '/vip/share/add',
        method: 'post',
        params,
        meta: {
            login: true,
            toast: true,
            loading: true,
        },
    });
}

/**
 * 会员中心支付
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const vipOrderAdd = (params = {}) => {
    return http({
        url: '/vip/order/add',
        method: 'post',
        params: { appId: config.appid, payType: 3, ...params },
        meta: {
            login: true,
            toast: true,
            loading: true,
            loadingText: '创建订单中'
        },
    });
}

/**
 * 会员支付记录
 * @param page
 * @returns {Promise | Promise<unknown>}
 */
export const vipRecordList = (page) => {
    return http({
        url: '/vip/record/list',
        method: 'get',
        params: { limit: 10, page },
        meta: {
            login: true,
            toast: true,
            loading: true,
            loadingText: '创建订单中'
        },
    });
}

/**
 * 会员体验卡落地页接口
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const vipShareData = (params = {}) => {
    return http({
        url: '/vip/share/data',
        method: 'get',
        params,
        meta: {
            login: true,
            toast: true,
            loading: true,
        },
    });
}

/**
 * 领取分享出去的会员卡
 * @returns {Promise | Promise<unknown>}
 * @param params
 */
export const vipShareReceive = (params) => {
    return http({
        url: '/vip/share/receive',
        method: 'post',
        params,
        meta: {
            toast: true,
            loading: true,
        },
    });
}

/**
 * 领取分享出去的会员卡 领取记录
 * @returns {Promise | Promise<unknown>}
 * @param params
 */
export const vipShareList = (params) => {
    return http({
        url: '/vip/share/list',
        method: 'get',
        params,
        meta: {
            toast: true,
            loading: true,
        },
    });
}
